import 'bulma/css/bulma.css'
import React, { SFC } from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import { PracticePage } from './pages/practice'
import { BattlePage } from './pages/battle'
import { CreateRoomPage } from './pages/room'
import { AppHeader } from './components/AppHeader'

const App: SFC = () => (
  <BrowserRouter>
    <div>
      <Route exact path='/' component={Home} />
      <Route path='/practice' component={PracticePage} />
      <Route path='/battle/:id' component={BattlePage} />
      <Route path='/room' component={CreateRoomPage} />
    </div>
  </BrowserRouter>
)

const Home: SFC = () => (
  <div>
    <AppHeader />
  </div>
)

export default App
